export const patternDimensions = {
  byDuration: {
    label: "By length",
    buckets: [
      { label: "1-15 min", keys: ["1-15"] },
      { label: "16-30 min", keys: ["16-30"] },
      { label: "31-60 min", keys: ["31-60"] },
      { label: "1-2 h", keys: ["61-120"] },
      { label: "2 h+", keys: ["moreThan120"] },
    ],
  },
  byAttendeesSize: {
    label: "By size",
    buckets: [
      { label: "2 people", keys: ["1:1"] },
      { label: "3-5 people", keys: ["3-5"] },
      { label: "6-10 people", keys: ["6-10"] },
      { label: "11+ people", keys: ["11-20", "20+"] },
    ],
  },
  byWeekdays: {
    label: "By day",
    buckets: [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ].map((day) => ({ label: day.slice(0, 3), keys: [day] })),
  },
};

export function getPatternRows(data, dimension) {
  return patternDimensions[dimension].buckets.map(({ label, keys }) => {
    let internal = 0;
    let external = 0;
    const ratings = [];
    for (const key of keys) {
      internal += data?.[key]?.internal?.totalMeetings || 0;
      external += data?.[key]?.external?.totalMeetings || 0;
      for (const type of ["internal", "external"]) {
        // Pool the per-meeting ratings instead of averaging bucket averages.
        ratings.push(
          ...(data?.[key]?.[type]?.ratings || []).filter(
            (value) => Number.isFinite(value) && value >= 0 && value <= 5,
          ),
        );
      }
    }
    return {
      label,
      keys,
      internal,
      external,
      total: internal + external,
      rating: ratings.length
        ? ratings.reduce((sum, value) => sum + value, 0) / ratings.length
        : null,
      ratedMeetings: ratings.length,
    };
  });
}

export function getPatternFindings(rows) {
  const total = rows.reduce((sum, row) => sum + row.total, 0);
  if (!total) return [];
  const busiest = rows.reduce((best, row) =>
    row.total > best.total ? row : best,
  );
  const findings = [
    `${busiest.label} has ${busiest.total} meetings, ${Math.round((busiest.total / total) * 100)}% of this view.`,
  ];
  const rated = rows.filter((row) => row.rating !== null && row.total > 0);
  if (rated.length) {
    const best = rated.reduce((best, row) =>
      row.rating > best.rating ? row : best,
    );
    findings.push(
      `${best.label} has ${rated.length > 1 ? "the highest average rating" : "an average rating"} of ${best.rating.toFixed(1)} across ${best.ratedMeetings} rated ${best.ratedMeetings === 1 ? "meeting" : "meetings"}.`,
    );
  }
  const unrated = rows.filter((row) => row.total > 0 && row.rating === null);
  if (unrated.length)
    findings.push(
      `${unrated.map((row) => row.label).join(", ")} ${unrated.length === 1 ? "has" : "have"} no ratings.`,
    );
  return findings;
}
